import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0F1020] flex items-center justify-center text-slate-300">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
